import { CheckboxGroup, Loading, TextSpan } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { RegionOptionResource } from "../../types/region";
import { RegionMultiSelectField } from "../../ui/RegionMultiSelectField";
import { FilterAccordionBody, FilterAccordionItem, FilterCheckbox } from "./AccordionFilterItemStyles";
import { useEventFilterAccordionItems } from "./EventFilterAccordionItemsProvider";

interface Props {
	name: string;
}

export const AccordionItemRegion: FC<Props> = ({ name }) => {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField<RegionOptionResource[]>(name);
	const { regions, regionsIsLoading, renderRegionsAsCheckboxes } = useEventFilterAccordionItems();

	if (!regions || !regions.length) {
		return null;
	}

	const renderBody = () => {
		if (regionsIsLoading) return <Loading />;
		if (renderRegionsAsCheckboxes) {
			return (
				<CheckboxGroup name={name}>
					{regions.map((region) => (
						<FilterCheckbox
							key={`${region.id}`}
							name={`region-${region.id}`}
							value={value.some((v) => v.id === region.id)}
							label={region.name}
							onChange={(e) => setValue(e.target.value ? [...value, region] : value.filter((v) => v.id !== region.id))}
						/>
					))}
				</CheckboxGroup>
			);
		}
		return <RegionMultiSelectField name={name} label="" />;
	};

	return (
		<FilterAccordionItem
			title={t("Region")}
			actions={<TextSpan $size="small">{t("IN_RELATION")}</TextSpan>}
			initialOpen={value && value.length > 0}
			body={<FilterAccordionBody>{renderBody()}</FilterAccordionBody>}
		/>
	);
};
